import { usePartners } from '@entities/partner'
import { MobileHeader } from '@widgets/mobile-header'
import type { TabsProps } from 'antd'
import { Button, Tabs, theme, Typography } from 'antd'
import { useMemo } from 'react'
import { Delete } from 'react-feather'
import { useNavigate, useParams } from 'react-router-dom'
import { AdvertisingPlatformsMobile } from './advertising-platforms.mobile'
import { MainFormMobile } from './main-form.mobile'
import { OrdFormMobile } from './ord-form.mobile'

const { Text } = Typography

export const EditPartnerPage = () => {
    const {
        token: { colorBgContainer, colorPrimary }
    } = theme.useToken()

    const { id } = useParams<{ id: string }>()

    const partnerId = id ? parseInt(id) : undefined

    const { currentPartner, isLinkedPartner } = usePartners({ id: partnerId })

    const targetPartner = useMemo(
        () => (currentPartner?.linkedPartner ? currentPartner?.linkedPartner : currentPartner),
        [currentPartner]
    )

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <Text style={{ fontSize: '17px' }}>Настройки</Text>,
            children: targetPartner ? (
                <MainFormMobile partner={targetPartner} isLinkedPartner={isLinkedPartner} />
            ) : undefined
        },
        {
            key: '2',
            label: <Text style={{ fontSize: '17px' }}>Интернет ресурсы</Text>,
            children: targetPartner ? (
                <AdvertisingPlatformsMobile partner={targetPartner} isLinkedPartner={isLinkedPartner} />
            ) : undefined
        },
        {
            key: '3',
            label: <Text style={{ fontSize: '17px' }}>ОРД</Text>,
            children: targetPartner ? (
                <OrdFormMobile partner={targetPartner} isLinkedPartner={isLinkedPartner} />
            ) : undefined
        }
    ]

    const navigate = useNavigate()

    return (
        <>
            <MobileHeader
                title={currentPartner?.name || ''}
                filter={
                    <Button type="text" onClick={() => navigate('/advertising/partners')}>
                        <Delete color={colorPrimary} />
                    </Button>
                }
            />
            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px',
                    overflow: 'auto',
                    flexGrow: 1
                }}
            >
                <Tabs defaultActiveKey="1" items={items} />
            </div>
        </>
    )
}
